import axios from 'axios';
import { API_MYEDUZZ, URL_ORBITA } from 'settings';
import type { ICard } from 'v2/components/Shared/SelectCreditCard';
import type { ICardApiResponse } from 'v2/interfaces/customer';
import type { ISubscriptions } from 'v2/interfaces/subscriptions';

export type AutomaticPixAuthorization = {
  barcode: string;
  subscriptionId: number;
  amountCents: number;
  interval: string;
  start: string | null;
  end: string | null;
  nextChargeDate: string | null;
  status: string;
  isPending: boolean;
  requestedAt: string;
  expiresAt: string;
  shortUrl: string;
};

class ChangePaymentMethodService {
  private token: string;

  public setToken(token: string) {
    this.token = token;
  }

  public getToken(): string {
    return this.token;
  }

  public async getAutomaticPixAuthorization(subscriptionId: string): Promise<AutomaticPixAuthorization> {
    const response = await axios({
      baseURL: URL_ORBITA,
      url: `/api/subscriptions/${subscriptionId}/automatic-pix-authorization`,
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    return response.data?.data ?? response.data;
  }

  public async getCards(): Promise<ICardApiResponse[]> {
    const response = await axios({
      baseURL: API_MYEDUZZ,
      url: '/subscriptions/payment-methods',
      method: 'GET',
      headers: {
        Authorization: this.getToken()
      }
    });

    return response.data.data.filter((card: ICardApiResponse) => card.holder);
  }

  public async getSubscription(): Promise<ISubscriptions> {
    const response = await axios({
      baseURL: API_MYEDUZZ,
      url: '/subscriptions/payment-methods/contract',
      method: 'GET',
      headers: {
        Authorization: this.getToken()
      }
    });

    return response.data.data;
  }

  public async saveNewCard(card: ICard) {
    return axios({
      baseURL: API_MYEDUZZ,
      url: '/subscriptions/payment-methods',
      method: 'POST',
      data: {
        number: card.number,
        holder: card.name.toUpperCase(),
        month: card.expiry.substr(0, 2),
        year: card.expiry.substr(3, 4),
        cvv: card.cvc
      },
      headers: {
        Authorization: this.getToken()
      }
    });
  }

  public changePayment(paymentId: number) {
    return axios({
      baseURL: API_MYEDUZZ,
      url: '/subscriptions/payment-methods/change-payment',
      method: 'POST',
      data: {
        payment_id: paymentId
      },
      headers: {
        Authorization: this.getToken()
      }
    });
  }
}

const changePaymentMethodService = new ChangePaymentMethodService();

export default changePaymentMethodService;
